import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { CtaButton } from './ui/CtaButton';
import { OFFER_ANCHOR, PACK_IMAGE, PRODUCT, systemFeatures } from '../data/content';
export function SystemSection() {
  return <section aria-labelledby="sistema" className="bg-cream" data-id="element-197" data-mp="3bkzokizh8tvo">
      <div className="mx-auto max-w-page px-3 py-6 sm:px-6 sm:py-8" data-id="element-198" data-mp="36iqu1i6yhjrg">
        <Reveal className="text-center" data-id="element-199" data-mp="31kgyh6hbkh5b">
          <p className="text-[0.62rem] font-extrabold uppercase tracking-[0.24em] text-coral sm:text-xs" data-id="element-200" data-mp="31lihpy8ho9y4">
            El sistema completo 6 en 1
          </p>
          <h2 id="sistema" className="mt-0.5 font-display text-xl font-black uppercase leading-[1.08] text-ink sm:text-3xl" data-id="element-201" data-mp="2ss5gm909u20y">
            {PRODUCT}
          </h2>
          <p className="mt-0.5 text-[0.72rem] font-extrabold uppercase tracking-[0.14em] text-ink-soft sm:text-[0.82rem]" data-id="element-202" data-mp="2ity4c3gxg85a">
            Método visual desde cero para principiantes
          </p>
        </Reveal>

        <div className="mt-4 grid items-center gap-4 lg:grid-cols-[1.1fr_1fr]" data-id="element-203" data-mp="13yof7rmwtwbd">
          <Reveal delay={0.04} data-id="element-204" data-mp="18py60vk735ou">
            <a href={OFFER_ANCHOR} className="block" data-id="element-205" data-mp="18qzqfqn3p4j8">
              <img src={PACK_IMAGE} alt={`Contenido incluido en ${PRODUCT}`} className="mx-auto w-full max-w-md rounded-xl border-2 border-blush" data-id="element-206" data-mp="18rr960vln7s3" />
            </a>
          </Reveal>

          <Reveal delay={0.08} data-id="element-207" data-mp="1mqr23kq5a8u2">
            <ul className="grid gap-1.5" data-id="element-208" data-mp="1mqhc3x53o1od">
              {systemFeatures.map(feature => <li key={feature} className="flex items-center gap-2 rounded-lg border-l-4 border-coral bg-white px-2.5 py-2 text-[0.78rem] font-bold uppercase text-ink sm:text-[0.82rem]" data-id="element-209" data-mp="1ro0y5j81hiqv">
                  <CheckIcon size={15} className="flex-shrink-0 text-gold" strokeWidth={3} data-id="element-210" data-mp="1cmjqe6tzedy" />
                  {feature}
                </li>)}
            </ul>
            <div className="mt-3 flex justify-center lg:justify-start" data-id="element-211" data-mp="28xl8qr8uhcj4">
              <CtaButton data-id="element-212" data-mp="2403071yqozbn">🔥 OBTÉN EL SISTEMA COMPLETO HOY</CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>;
}